export async function requestForwardFeed(data: {
  content: string
  resourceId: number
  resourceType: ResourceType
}) {
  return http.post('/v1/feeds/forward', {
    content: data.content,
    resource_type: data.resourceType,
    resource_id: data.resourceId
  })
}
